<template>
  <div class="phone-input">
    <div class="form-group row" :class="{ 'has-feedback' : isDirty }">
      <label :for="options.name" :class="options.fullWidth ? 'col-sm-12' : 'col-sm-4 col-form-label'">
        {{ options.label }}
        <span v-if="options.required" class="required">*</span>
      </label>
      <div :class="options.fullWidth ? 'col-sm-12' : 'col-sm-8'">
        <input class="form-control" type="text"
          :id="options.name"
          @input="validate($event.target.value)"
          :value="value"
          :name="options.name"/>
        <span :class="validationClass" v-show="validationMessage">
          {{ validationMessage }}
        </span>
        <span :class="validationIcon" v-show="validationIcon"></span>
      </div>
    </div>
  </div>
</template>

<script>
import {
  validationClass,
  validationMessage,
  validationIcon
} from '@/util/helpers'

export default {
  name: 'PhoneInput',
  props: {
    value: {
      type: String
    },
    options: {
      type: Object,
      default () {
        return {
          value: '',
          required: false
        }
      }
    }
  },
  data () {
    return {
      invalidMessage: 'Phone number entered is not valid',
      isDirty: false,
      isValid: false,
      isLength: false,
      isRegex: false,
      minLength: 1,
      regex: /^[0-9-()+\s]{5,}$/
    }
  },
  computed: {
    validationClass,
    validationMessage,
    validationIcon
  },
  methods: {
    validate (val = this.value) {
      this.$emit('input', val)
      if (val) {
        this.isDirty = true
        this.isLength = this.isValid = val.length > this.minLength
        if (this.isLength) this.isRegex = this.isValid = new RegExp(this.regex, 'gi').test(val)
      } else if (this.options.required) {
        this.isDirty = true
        this.isValid = false
      } else {
        this.isValid = true
        this.isDirty = false
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/inputs/PhoneInput.vue